import { render, staticRenderFns } from "./Yodlee.vue?vue&type=template&id=4a94b736&scoped=true"
import script from "./Yodlee.vue?vue&type=script&lang=js"
export * from "./Yodlee.vue?vue&type=script&lang=js"
import style0 from "./Yodlee.vue?vue&type=style&index=0&id=4a94b736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94b736",
  null
  
)

export default component.exports